import { render, staticRenderFns } from "./DemographicField.vue?vue&type=template&id=f2314628&scoped=true"
import script from "./DemographicField.vue?vue&type=script&lang=js"
export * from "./DemographicField.vue?vue&type=script&lang=js"
import style0 from "./DemographicField.vue?vue&type=style&index=0&id=f2314628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2314628",
  null
  
)

export default component.exports